module.exports = __webpack_public_path__ + "img/logo.06ee7ef3.svg";